import { call, put, select } from 'redux-saga/effects';
import { updateCA as updateCAAda } from '@bitComponents/adabyron/cqv2';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

export const changeAccountToServerView = (customerAccount) => {
  if (!customerAccount) {
    return null;
  }
  const customerAccountWithoutSpaces = customerAccount.replace(/\s/g, '');
  const ibanCountryIso2Code = customerAccountWithoutSpaces.slice(0, 2);
  const ibanCheckDigits = customerAccountWithoutSpaces.slice(2, 4);
  const bankEntityCode = customerAccountWithoutSpaces.slice(4, 8);
  const bankOfficeCode = customerAccountWithoutSpaces.slice(8, 12);
  const spanishIbanCheckDigits = customerAccountWithoutSpaces.slice(12, 14);
  const spanishIbanAccountNumber = customerAccountWithoutSpaces.slice(14);

  return {
    bankEntityCode,
    bankOfficeCode,
    ibanCheckDigits,
    ibanCountryIso2Code,
    spanishIbanAccountNumber,
    spanishIbanCheckDigits,
  };
};

export function* updateCA(params) {
  const {
    reduxUpdate,
    cqId,
    customerAccount,
    normalizeHttpErrors,
  } = params;

  try {
    const context = yield select(contextStore);
    const { successUpdate } = reduxUpdate;
    const args = {
      cqId,
    };
    if (customerAccount && customerAccount.customerAccountId) {
      const { customerAccountId } = customerAccount;
      args.customerAccount = {
        customerAccountId,
      };
    } else if (customerAccount && customerAccount.customerAccountNumber) {
      args.customerAccount = {
        customerAccountName: 'Mi cuenta',
        ...changeAccountToServerView(customerAccount.customerAccountNumber),
      };
    }

    const response = yield call(updateCAAda, args, context);

    if (successUpdate) {
      yield put(successUpdate(response));
    }

    return response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.UPDATE_CA, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
